import { faUserGroup } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@repo/videa-components/src/ui/tooltip';
import { useSetAtom } from 'jotai';
import { useHistory } from 'react-router-dom';

import { viewPracticeGroupsAtom } from '../../modules/insights/atoms';
import routesConstants from '../../routes/routes.constants';

export const PracticeGroupsButton = () => {
  const setViewPracticeGroups = useSetAtom(viewPracticeGroupsAtom);

  const history = useHistory();

  return (
    <Tooltip>
      <TooltipTrigger className="vai-bg-transparent vai-border-none vai-px-0 vai-p-0">
        <Button
          size="icon"
          variant="icon"
          data-testid="view-practice-groups-button"
          onClick={() => {
            history.push(routesConstants.PRACTICE_GROUPS);
            setViewPracticeGroups(true);
          }}
        >
          <FontAwesomeIcon icon={faUserGroup} color="white" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <span>
          <Trans>View DSO Regions</Trans>
        </span>
      </TooltipContent>
    </Tooltip>
  );
};
